import { EColumnType, TTableColumns } from '@/components/table/types';
import { getTranslate } from '@/helpers/translateHelpers';
import { TestTableColumnsData } from '@/services/dataServices';
import { tableFieldConvert } from './tableConfigs';

export const COLUMNS: TTableColumns = [
  {
    name: getTranslate('pages.existReports.name'),
    field: tableFieldConvert('name'),
    useInFilter: false,
    type: EColumnType.link,
    useSort: false,
    options: {
      width: '20%',
    },
  },
  {
    name: getTranslate('pages.existReports.description'),
    field: tableFieldConvert('description'),
    useInFilter: false,
    type: EColumnType.text,
    useSort: false,
    options: {
      width: '30%',
    },
  },
];

const DATA = [
  {
    name: {
      name: 'Отчёт по кампаниям',
      link: 'https://app.bidadvert.ru/report-builder?dimensions=performance-campaign_id&metrics=performance-impression&metrics=performance-clicks&metrics=performance-spend&metrics=performance-cpc&metrics=performance-ctr&metrics=post_tracking-order&metrics=post_tracking-confirmed&metrics=post_tracking-revenue&metrics=post_tracking-roi&page=1&per__page=20',
    },
    description: 'Продуктивность кампаний',
  },
  {
    name: {
      name: 'Отчёт по креативам',
      link: 'https://app.bidadvert.ru/report-builder?dimensions=performance-creative_id&metrics=performance-impression&metrics=performance-clicks&metrics=performance-spend&metrics=performance-ctr&metrics=performance-cpc&metrics=post_tracking-confirmed&metrics=post_tracking-order&metrics=post_tracking-revenue&metrics=post_tracking-roi&page=1&per__page=20',
    },
    description: 'Продуктивность креативов',
  },
  {
    name: {
      name: 'Отчёт по источникам',
      link: 'https://app.bidadvert.ru/report-builder?dimensions=source-domain&metrics=performance-impression&metrics=performance-clicks&metrics=performance-spend&metrics=performance-ctr&metrics=performance-cpc&metrics=post_tracking-confirmed&metrics=post_tracking-order&metrics=post_tracking-revenue&metrics=post_tracking-roi&page=1&per__page=20&sort=-impression',
    },
    description: 'Продуктивность источников',
  },
  {
    name: {
      name: 'Отчёт по группам',
      link: 'https://app.bidadvert.ru/report-builder?dimensions=performance-group_id&metrics=performance-impression&metrics=performance-clicks&metrics=performance-spend&metrics=performance-cpc&metrics=performance-ctr&metrics=post_tracking-order&metrics=post_tracking-confirmed&metrics=post_tracking-revenue&metrics=post_tracking-roi&page=1&per__page=20',
    },
    description: 'Продуктивность групп',
  },
  {
    name: {
      name: "Отчёт по расходам за сегодня",
      link: 'https://app.bidadvert.ru/report-builder?dimensions=time_unit-hour&metrics=performance-spend&page=1&per__page=20&sort=-impression',
    },
    description: 'Все расходы за сегодня',
  },
  {
    name: {
      name: 'Отчёт по страницам',
      link: 'https://app.bidadvert.ru/report-builder?dimensions=source-category_page&metrics=performance-impression&metrics=performance-clicks&metrics=performance-spend&metrics=performance-ctr&metrics=performance-cpc&metrics=post_tracking-order&metrics=post_tracking-confirmed&metrics=post_tracking-revenue&metrics=post_tracking-roi&page=1&per__page=20&sort=-impression',
    },
    description: 'Продуктивность страниц',
  },
  {
    name: {
      name: 'Отчёт по девайсам',
      link: 'https://app.bidadvert.ru/report-builder?dimensions=device-device_type&metrics=performance-impression&metrics=performance-clicks&metrics=performance-spend&metrics=performance-ctr&metrics=performance-cpc&metrics=post_tracking-order&metrics=post_tracking-confirmed&metrics=post_tracking-revenue&metrics=post_tracking-roi&page=1&per__page=20&sort=-impression',
    },
    description: 'Продуктивность платформы',
  },
];

const data = () => {
  return DATA;
};

export const columns: TestTableColumnsData = new TestTableColumnsData(
  COLUMNS,
  data
);
